<script>
    import FancyButton from './FancyButton.svelte';
</script>


<FancyButton label="Play as a Call Center Rep" image={"/callcenterrep.svg"}/>